import {
  AppstoreOutlined,
  PushpinOutlined,
  ShopOutlined,
} from "@ant-design/icons";
import { Menu } from "antd";
import React, { ReactElement } from "react";
import { Link } from "react-router-dom";

const CampaignSidebar = ({ campaignId }): ReactElement => {
  const pathname = window.location?.pathname;

  return (
    <>
      <div className="h-100 product-details-wrapper-content">
        <div className="aside-menu">
          <Menu
            defaultSelectedKeys={["0"]}
            // defaultOpenKeys={['sub1']}
            mode="inline"
          >
            <Menu.Item
              key="details"
              className={pathname.includes("details") ? "active" : ""}
              icon={<ShopOutlined />}
            >
              <Link to={`/promotions/campaigns/details/${campaignId}`}>
                Campaign Information
              </Link>
            </Menu.Item>

            <Menu.Item
              key="/products"
              icon={<AppstoreOutlined />}
              className={pathname.includes("/products") ? "active" : ""}
            >
              <Link to={`/promotions/campaigns/${campaignId}/products`}>
                Product Management
              </Link>
            </Menu.Item>
            <Menu.Item
              key="/products"
              icon={<AppstoreOutlined />}
              className={pathname.includes("/products") ? "active" : ""}
            >
              <Link to={`/promotions/campaigns/${campaignId}/products`}>
                Shop Management
              </Link>
            </Menu.Item>
            {/* <Menu.Item
              key="areas"
              icon={<PushpinOutlined />}
              className={pathname.includes("/areas") ? "active" : ""}
            >
              <Link to={`/campaigns/${campaignId}/areas`}>Area Management</Link>
            </Menu.Item> */}
          </Menu>
        </div>
      </div>
    </>
  );
};

export default CampaignSidebar;
